import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nSharedConfig } from 'utils/shared/utils';
import { i18nConfig as i18nUiConfig } from 'utils/ui';

export interface i18nFlightConfigProps {
  enTranslation: any;
  heTranslation: any;
  esTranslation: any;
}

export const i18nFlightConfig = (props: i18nFlightConfigProps) => {
  const lang = localStorage.getItem('language');

  i18nSharedConfig({ ...props, ruTranslation: {} });
  i18nUiConfig(props);

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: props.enTranslation,
      },
      he: {
        translation: props.heTranslation,
      },
      es: {
        translation: props.esTranslation,
      },
    },
    lng: lang ? lang : 'he',
    fallbackLng: 'he',

    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
